export default __webpack_public_path__ + "static/media/ic_uncheck.338849bc.svg";